import { render, staticRenderFns } from "./form-type.vue?vue&type=template&id=13a43002&scoped=true&"
import script from "./form-type.vue?vue&type=script&lang=js&"
export * from "./form-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a43002",
  null
  
)

export default component.exports